import {NgModule} from '@angular/core';
import {HorizontalLoaderComponent} from './horizontal-loader.component';

@NgModule({
    exports: [HorizontalLoaderComponent],
    declarations: [HorizontalLoaderComponent]
})
export class HorizontalLoaderModule {
}